import { RouteRecordRaw } from "vue-router";

import Apply from "@/views/Apply.vue";
import Pensionwise from "@/views/PensionwiseNudge.vue";
import ApplicationInformation from "@/components/ApplicationInformation.vue";
import ApplicationDefenceLine from "@/components/ApplicationDefenceLine.vue";
import ApplicationDetails from "@/components/ApplicationDetails.vue";
import ApplicationPensionFund from "@/components/ApplicationPensionFund.vue";
import ApplicationCompleteAndSend from "@/components/ApplicationCompleteAndSend.vue";
import ApplicationAlmostThere from "@/views/Apply/components/ApplicationAlmostThere/ApplicationAlmostThere.vue";
import ApplicationSentLnG from "@/views/Apply/components/ApplicationSentLnG/ApplicationSentLnG.vue";
import DownloadAndPrint from "@/views/Apply/components/DownloadAndPrint/DownloadAndPrint.vue";
import PostPack from "@/views/Apply/components/PostPack/PostPack.vue";
import { ApplyPageStages, useApplicationStore, ApplyCompletedStages } from "@/stores/application";
import { RESULT_APPLY_TITLE } from "@/constants/pageTitles";

const apply: Array<RouteRecordRaw> = [{
    path: "/apply",
    name: "apply",
    component: Apply,
    meta: { title: RESULT_APPLY_TITLE },
    beforeEnter: (to) => {
        if (to.name !== ApplyPageStages[ApplyPageStages.Information] &&
            to.name !== ApplyPageStages[ApplyPageStages.PensionWise]) {
            return { name: ApplyPageStages[ApplyPageStages.Information], query: to.query };
        }
    },
    children: [
        {
            path: "PW",
            name: ApplyPageStages[ApplyPageStages.PensionWise],
            component: Pensionwise,
            meta: {
                formStage: ApplyPageStages.PensionWise,
            },
        },
        {
            path: `${ApplyPageStages.Information}`,
            name: ApplyPageStages[ApplyPageStages.Information],
            component: ApplicationInformation,
            meta: {
                formStage: ApplyPageStages.Information,
            },
        },
        {
            path: `${ApplyPageStages.DefenseLine}`,
            name: ApplyPageStages[ApplyPageStages.DefenseLine],
            component: ApplicationDefenceLine,
            meta: {
                formStage: ApplyPageStages.DefenseLine,
            },
        },
        {
            path: `${ApplyPageStages.AboutYou}`,
            name: ApplyPageStages[ApplyPageStages.AboutYou],
            component: ApplicationDetails,
            meta: {
                formStage: ApplyPageStages.AboutYou,
            },
        },
        {
            path: `${ApplyPageStages.DependantAboutYou}`,
            name: ApplyPageStages[ApplyPageStages.DependantAboutYou],
            component: ApplicationDetails,
            beforeEnter: (to, from) => {
                const application = useApplicationStore();
                if (application.applicantDetails.length === 1) {
                    if (from.meta?.formStage === ApplyPageStages.PensionFundDetails) {
                        return { name: ApplyPageStages[ApplyPageStages.AboutYou], query: to.query };
                    } else if (from.meta?.formStage === ApplyPageStages.AboutYou) {
                        return { name: ApplyPageStages[ApplyPageStages.PensionFundDetails], query: to.query };
                    }
                }
            },
            meta: {
                formStage: ApplyPageStages.DependantAboutYou,
            },
        },
        {
            path: `${ApplyPageStages.PensionFundDetails}`,
            name: ApplyPageStages[ApplyPageStages.PensionFundDetails],
            component: ApplicationPensionFund,
            meta: {
                formStage: ApplyPageStages.PensionFundDetails,
            },
        },
        {
            path: `${ApplyPageStages.CompleteAndSend}`,
            name: ApplyPageStages[ApplyPageStages.CompleteAndSend],
            component: ApplicationCompleteAndSend,
            meta: {
                formStage: ApplyPageStages.CompleteAndSend,
            },
        },
        {
            path: `${ApplyPageStages.NearlyThere}`,
            name: ApplyPageStages[ApplyPageStages.NearlyThere],
            component: ApplicationAlmostThere,
            meta: {
                formStage: ApplyPageStages.NearlyThere,
            },
        },
        {
            path: ApplyCompletedStages.SendDirectToLnG,
            name: ApplyCompletedStages.SendDirectToLnG,
            component: ApplicationSentLnG,
        },
        {
            path: ApplyCompletedStages.SendDirectToPostPack,
            name: ApplyCompletedStages.SendDirectToPostPack,
            component: PostPack,
        },
        {
            path: ApplyCompletedStages.SendDirectToDownloadAndPrint,
            name: ApplyCompletedStages.SendDirectToDownloadAndPrint,
            component: DownloadAndPrint,
        },
    ],
}];

export default apply;
